import React, { useEffect } from 'react';
import { Modal } from 'antd';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { CachedImage } from '../../components/CachedImage';
import Loading from '../../components/Loading/Loading';
import { personalModel } from './PersonalModel';
import './PersonalStyle.css';

const displayText = (value?: string) =>
  value && value.trim() ? value : '未设置';

interface PersonalModalProps {
  visible: boolean;
  onClose: () => void;
}

const PersonalModal: React.FC<PersonalModalProps> = observer(
  ({ visible, onClose }) => {
    const navigate = useNavigate();
    const { loading, error, profile } = personalModel;

    useEffect(() => {
      if (!visible) {
        personalModel.reset();
        return;
      }
      personalModel.load();
    }, [visible]);

    const handleDownloadApp = () => {
      onClose();
      navigate('/download-app');
    };

    return (
      <Modal
        open={visible}
        title="个人信息"
        onCancel={onClose}
        footer={null}
        width={480}
        centered
        destroyOnClose
        className="personal-modal"
      >
        <div className="personal-modal-body">
          <div className="personal-app-tip">
            如需修改个人信息，请前往圆领买家 APP。
            <span
              className="personal-app-tip-link"
              onClick={handleDownloadApp}
            >
              下载 APP
            </span>
          </div>

          {loading ? (
            <Loading />
          ) : error || !profile ? (
            <div className="personal-page-state">{error || '加载失败'}</div>
          ) : (
            <div className="personal-info-list">
              <div className="personal-info-row">
                <span className="personal-info-label">头像</span>
                {profile.avatarUrl ? (
                  <CachedImage
                    url={profile.avatarUrl}
                    style={{
                      marginLeft: 'auto',
                      width: 48,
                      height: 48,
                      borderRadius: 4,
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <div className="personal-info-avatar-placeholder" />
                )}
              </div>
              <div className="personal-info-row">
                <span className="personal-info-label">昵称</span>
                <span className="personal-info-value">
                  {displayText(profile.nickname)}
                </span>
              </div>
              <div className="personal-info-row">
                <span className="personal-info-label">手机号</span>
                <span className="personal-info-value">
                  {displayText(profile.phone)}
                </span>
              </div>
              <div className="personal-info-row">
                <span className="personal-info-label">性别</span>
                <span className="personal-info-value">
                  {displayText(profile.gender)}
                </span>
              </div>
              {profile.isCompany ? (
                <div className="personal-info-row">
                  <span className="personal-info-label">所属企业</span>
                  <span className="personal-info-value">
                    {profile.company && profile.company.trim()
                      ? profile.company
                      : '企业用户'}
                  </span>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </Modal>
    );
  },
);

export default PersonalModal;
